export default "__VITE_ASSET__CgV5G1P1__"